import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import TextField from '@mui/material/TextField'
import Typography from '@mui/material/Typography'
import { useForm } from 'react-hook-form'
import { BorderContainer } from '../borderedContainer'

export interface CreateMandateOverforselsServiceFormValues {
  bankAccount: string
  contactInfo: {
    fullname: string
    phonenumber: string
    email: string
  }
}

interface DirectDebitTabNewConnection {
  onCreateMandate: (data: CreateMandateOverforselsServiceFormValues) => void
  isLoading?: boolean
}

export const CreateMandateOverforselsService = ({ onCreateMandate, isLoading }: DirectDebitTabNewConnection) => {
  const handleSubmit = (data: CreateMandateOverforselsServiceFormValues) => {
    onCreateMandate(data)
  }

  const form = useForm<CreateMandateOverforselsServiceFormValues>({
    defaultValues: {
      bankAccount: '',
      contactInfo: {
        fullname: '',
        phonenumber: '+45',
        email: '',
      },
    },
  })

  return (
    <BorderContainer aria-label="overforselservice" gap={3}>
      <Box display="flex" flexDirection="column" gap={1}>
        <Typography variant="body1" color="text.primary" fontWeight={600}>
          Set bank account number
        </Typography>
      </Box>
      <Box display="flex" flexDirection="column" gap={3}>
        <Box display="flex" flexDirection="column" gap={1.5}>
          <Typography variant="subtitle1" color="text.secondary">
            Bank account details
          </Typography>
          <Box display="flex" flexDirection="column" gap={2}>
            <TextField aria-label="account-number" {...form.register('bankAccount')} label="Bank account" />
          </Box>
        </Box>
        <Box display="flex" flexDirection="column" gap={1.5}>
          <Typography variant="subtitle1" color="text.secondary">
            Signatory contact information
          </Typography>
          <Box display="flex" flexDirection="column" gap={2}>
            <TextField aria-label="fullname" {...form.register('contactInfo.fullname')} label="Fullname" />
            <TextField aria-label="phonenumber" type="tel" {...form.register('contactInfo.phonenumber')} label="Phone number" />
            <TextField aria-label="email" type="email" {...form.register('contactInfo.email')} label="Email" />
          </Box>
        </Box>
      </Box>
      <Box display="flex" flexDirection="column" gap={2}>
        <Box>
          <Button disabled={isLoading} onClick={form.handleSubmit(handleSubmit)} variant="primary">
            Create bank account
          </Button>
        </Box>
      </Box>
    </BorderContainer>
  )
}
